module.exports = __webpack_public_path__ + "static/media/2 (18).9994ef69.jpg";